export const SET_ACTIVE_SLIDER = 'setActiveSliderGallery';
export const TOGGLE_VISIBILITY = 'toggleVisibilityGallery';

export const GET_GALLERY_PENDING = 'getGalleryPending';
export const GET_GALLERY_FULFILLED = 'getGalleryFulfilled';
export const GET_GALLERY_REJECTED = 'getGalleryRejected';
